import { Channel } from '.';
import { ActivityType, UserBuilder } from '..';
import { AutoRoutingAssignmentStatus } from './enums/auto-routing-assignment-status.enum';
var AutoRoutingAssignmentBuilder = /** @class */ (function () {
    function AutoRoutingAssignmentBuilder() {
        this.item = {
            id: 'b0000b0b-b0b0-b0b0-b0b0-b0bb0bb00b0b',
            tenantId: 'b0000b0b-b0b0-b0b0-b0b0-b0bb0bb00b0b',
            ticketId: 'b0000b0b-b0b0-b0b0-bb0-b0bb000b00b0b',
            channel: Channel.WEB,
            activityType: ActivityType.TICKETING,
            user: new UserBuilder().build(),
            status: AutoRoutingAssignmentStatus.USER_ACCEPTED,
            eventCreationDate: Date.now(),
            creationDate: Date.now() - 3600000,
            lastUpdateDate: Date.now(),
        };
    }
    AutoRoutingAssignmentBuilder.prototype.withId = function (id) {
        this.item.id = id;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withTenantId = function (tenantId) {
        this.item.tenantId = tenantId;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withTicketId = function (ticketId) {
        this.item.ticketId = ticketId;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withUser = function (user) {
        this.item.user = user;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withChannel = function (channel) {
        this.item.channel = channel;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withActivityType = function (activityType) {
        this.item.activityType = activityType;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withStatus = function (status) {
        this.item.status = status;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withEventCreationDate = function (eventCreationDate) {
        this.item.eventCreationDate = eventCreationDate;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withCreationDate = function (creationDate) {
        this.item.creationDate = creationDate;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.item.lastUpdateDate = lastUpdateDate;
        return this;
    };
    AutoRoutingAssignmentBuilder.prototype.build = function () {
        return this.item;
    };
    return AutoRoutingAssignmentBuilder;
}());
export { AutoRoutingAssignmentBuilder };
//# sourceMappingURL=auto-routing-assignment.builder.js.map